import { connect } from 'react-redux'
import * as api from '../../../actions/api'
import * as actions from '../../../actions'
import { PuzzleListCard } from '../../../components'
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query'

const mapStateToProps = (state, ownProps) => {
  const { records, anchorEl, totalRows, totalPage, search, urlParams, isFetching, ready } = state.puzzleListCard
  const { user } = state.authentication
  const { width } = state.window

  return ({
    user,
    windowWidth: width,
    records,
    anchorEl,
    totalRows,
    totalPage,
    search,
    urlParams,
    isFetching,
    ready,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  var urlParams, page
  return ({
    init: (author) => {
      urlParams = {
        author: author ? undefined : ownProps.at,
        tag: ownProps.tg,
        word: ownProps.wd ? decodeURIComponent(ownProps.wd) : undefined,
        page: ownProps.pg ? ownProps.pg : 1,
        rowsPerPage: ownProps.rp ? ownProps.rp : 10
      }
      dispatch(actions.puzzleListCard.changedURLParams(urlParams))
      dispatch(actions.puzzleListCard.requestSelectPuzzle())
      dispatch(api.puzzle.select(
        {
          limit: urlParams.rowsPerPage,
          offset: (urlParams.page - 1) * urlParams.rowsPerPage,
          word: urlParams.word,
          tag: urlParams.tag,
          author: author ? author : urlParams.author,
          own: ownProps.own,
        },
        (response) => {
          dispatch(actions.puzzleListCard.responseSelectPuzzle(response))
        }
      ))
    },
    unmount: () => {
      dispatch(actions.puzzleListCard.unmount())
    },
    menu: {
      handleClick: (event) => {
        dispatch(actions.puzzleListCard.menu.open(event.currentTarget))
      },
      handleClose: () => {
        dispatch(actions.puzzleHome.menu.close())
      }
    },
    pageNavigation: {
      handleClick: (type, urlParams) => () => {
        switch(type) {
          case 'Next': page = urlParams.page + 1; break;
          case 'Back': page = urlParams.page - 1; break;
          default: return;
        }
        dispatch(actions.puzzleListCard.changedURLParams({ page }))
        ownProps.onChangePg(page)
        dispatch(actions.puzzleListCard.requestSelectPuzzle())
        dispatch(api.puzzle.select(
          {
            limit: urlParams.rowsPerPage,
            offset: (page - 1) * urlParams.rowsPerPage,
            word: urlParams.word,
            tag: urlParams.tag,
            author: ownProps.author ? ownProps.author : urlParams.author,
            own: ownProps.own,
          },
          (response) => {
            dispatch(actions.puzzleListCard.responseSelectPuzzle(response))
          }
        ))
      }
    },
    searchProp: {
      handleKeyDown: (urlParams) => (event) => {
        if (event.keyCode === 13){
          if (event.target.value.length === 0) {
            dispatch(actions.puzzleListCard.changedURLParams({
              page: 1,
              author: ownProps.author,
              word: ''
            }))
            ownProps.onChangeWd(undefined)
            ownProps.onChangeAt(undefined)
            ownProps.onChangeTg(undefined)
            ownProps.onChangePg(undefined)
            dispatch(actions.puzzleListCard.requestSelectPuzzle())
            dispatch(api.puzzle.select(
              {
                limit: urlParams.rowsPerPage,
                author: ownProps.author ? ownProps.author : undefined,
                own: ownProps.own,
              },
              (response) => {
                dispatch(actions.puzzleListCard.responseSelectPuzzle(response))
              }
            ))
          }
          else {
            dispatch(actions.puzzleListCard.changedURLParams({
              page: 1,
              tag: '',
              word: event.target.value,
            }))
            ownProps.onChangeWd(encodeURIComponent(event.target.value))
            ownProps.onChangeAt(undefined)
            ownProps.onChangeTg(undefined)
            ownProps.onChangePg(undefined)
            dispatch(actions.puzzleListCard.requestSelectPuzzle())
            dispatch(api.puzzle.select(
              {
                limit: urlParams.rowsPerPage,
                word: event.target.value,
                author: ownProps.author ? ownProps.author : undefined,
                own: ownProps.own,
              },
              (response) => {
                dispatch(actions.puzzleListCard.responseSelectPuzzle(response))
              }
            ))
          }
        }
      },
    }
  })
}

const urlPropsQueryConfig = {
  tg: { type: UrlQueryParamTypes.string },
  wd: { type: UrlQueryParamTypes.string },
  at: { type: UrlQueryParamTypes.string },
  pg: { type: UrlQueryParamTypes.number },
  rp: { type: UrlQueryParamTypes.number },
}

export default addUrlProps({ urlPropsQueryConfig })(connect(
  mapStateToProps,
  mapDispatchToProps,
)(PuzzleListCard))


// WEBPACK FOOTER //
// ./src/containers/Common/Puzzle/PuzzleListCard.js